import React from "react";
import { NavLink } from "react-router-dom";
import { FaHome, FaListAlt, FaPlusCircle, FaBuilding } from "react-icons/fa";
import LogoHeader from "../Assets/images/rk_logo.png";
import "../Assets/WebsiteCss/sidebar.css";

const Sidebar = () => {
  return (
    <div className="sidebar">
      {/* LOGO */}
      <div className="logo text-center mb-4">
        <img src={LogoHeader} alt="Logo" style={{ height: "50px" }} />
      </div>

      <ul className="sidebar-nav list-unstyled px-2">
        {/* DASHBOARD */}
        <li>
          <NavLink
            to="/dashboard"
            end
            className="d-flex align-items-center gap-2"
          >
            <FaHome /> Dashboard
          </NavLink>
        </li>

        {/* PROJECT */}
        {/* <li className="mt-3 text-muted fw-bold small">PROJECT</li> */}
        <li>
          <NavLink
            to="/dashboard/add-project"
            className="d-flex align-items-center gap-2"
          >
            <FaPlusCircle /> Add Project
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/dashboard/projects"
            className="d-flex align-items-center gap-2"
          >
            <FaBuilding /> All Projects
          </NavLink>
        </li>

        {/* CATEGORIES */}
        <li>
          <NavLink
            to="/dashboard/categories"
            className="d-flex align-items-center gap-2"
          >
            <FaListAlt /> Categories
          </NavLink>
        </li>
      </ul>
    </div>
  );
};

export default Sidebar;
